module.exports = __webpack_public_path__ + "static/media/students.ab048002.svg";